import React from 'react';
import { withRouter } from 'react-router-dom';
import { Formik } from 'formik';
import { FormattedMessage, injectIntl } from 'react-intl';
import axios from 'axios';

const ModalVivenciado = (props) => {

   const intl = props.intl;

   const placeholder1 = intl.formatMessage({
      id: "home.modal_vivenciadas.placeholder1"
   });
   const placeholder2 = intl.formatMessage({
      id: "home.modal_vivenciadas.placeholder2"
   });
   const placeholder3 = intl.formatMessage({
      id: "home.modal_vivenciadas.placeholder3"
   });
   const placeholder4 = intl.formatMessage({
      id: "home.modal_vivenciadas.placeholder4"
   });
   const placeholder5 = intl.formatMessage({
      id: "home.modal_situ.placeholder5"
   });

   function enviarDados(event, values) {
      event.preventDefault();
      axios.post('https://covidback19.herokuapp.com/denuncias', {respondida: 0, ...values}).then(() => {
         alert(intl.formatMessage({
            id: "home.modal_situ.button_submit"
         }));
         props.history.push('/');
      });
   }
   
   return(
         <div className="col-md-12">
            <div className="modal__header">
               <h1><FormattedMessage id="home.modal_vivenciadas.h1"/></h1>
               <h4><FormattedMessage id="home.modal_vivenciadas.h4"/></h4>
               <p><FormattedMessage id="home.modal_vivenciadas.p"/></p>
            </div>
          <Formik
                  
            initialValues={{ 
               nome: '', 
               email: '', 
               vulnerabilidade: '',
               data: '',
               idade: '',
               periodo: '',
               endereco: ''
            }}
         >
            {({
               values,
               errors,
               touched,
               handleChange,
               handleBlur,
               handleSubmit,
               isSubmitting,
            }) => (
               <form className="form" onSubmit={event => enviarDados(event, values)}>
                  <div className="row">
                      <div className="col-md-12">
                        <div className="form-group">
                           <label className="form-label" htmlFor="diagnostico"><FormattedMessage id="home.modal_vivenciadas.label1"/><span className="form-required">*</span></label>
                           <select
                              className={`form-input ${ errors.diagnostico && touched.diagnostico ? 'is-invalid' : '' }`}
                              name="diagnostico"
                              placeholder="Já teve diagnóstico positivo ao novo coronavírus?"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.diagnostico}
                           >
                              <option value="1">{ intl.formatMessage({id: "home.modal_vivenciadas.option1"}) }</option>
                              <option value="2">{ intl.formatMessage({id: "home.modal_vivenciadas.option2"}) }</option>
                           </select>
                        </div>
                     </div>

                      <div className="col-md-12">
                        <div className="form-group">
                           <label className="form-label" htmlFor="sintomas"><FormattedMessage id="home.modal_vivenciadas.label2"/><span className="form-required">*</span></label>
                           <select
                              className={`form-input ${ errors.sintomas && touched.sintomas ? 'is-invalid' : '' }`}
                              name="diagnostico"
                              placeholder="Desenvolveu sintomas compatíveis com COVID-19?"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.sintomas}
                           >
                              <option value="1">{ intl.formatMessage({id: "home.modal_vivenciadas.option3"}) }</option>
                              <option value="2">{ intl.formatMessage({id: "home.modal_vivenciadas.option4"}) }</option>
                           </select>
                        </div>
                     </div>

                     <div className="col-md-12">
                        <div className="form-group">
                           <label className="form-label" htmlFor="paciente"><FormattedMessage id="home.modal_vivenciadas.label3"/><span className="form-required">*</span></label>
                           <select
                              className={`form-input ${ errors.paciente && touched.paciente ? 'is-invalid' : '' }`}
                              name="paciente"
                              placeholder="Teve contato direto com paciente sintomático no ambiente de trabalho?"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.paciente}
                           >
                              <option value="1">{ intl.formatMessage({id: "home.modal_vivenciadas.option5"}) }</option>
                              <option value="2">{ intl.formatMessage({id: "home.modal_vivenciadas.option6"}) }</option>
                           </select>
                        </div>
                     </div>
                     
                     <div className="col-md-12">
                        <div className="form-group">
                           <label className="form-label" htmlFor="vulnerabilidade"><FormattedMessage id="home.modal_vivenciadas.label4"/><span className="form-required">*</span></label>
                           <select
                              className={`form-input ${ errors.vulnerabilidade && touched.vulnerabilidade ? 'is-invalid' : '' }`}
                              name="vulnerabilidade"
                              placeholder="Tipo de vulnerabilidade presenciada por você"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.vulnerabilidade}
                           >
                              <option value={ intl.formatMessage({id: "home.modal_vivenciadas.option7"}) }>{ intl.formatMessage({id: "home.modal_vivenciadas.option7"}) }</option>
                              <option value={ intl.formatMessage({id: "home.modal_vivenciadas.option8"}) }>{ intl.formatMessage({id: "home.modal_vivenciadas.option8"}) }</option>
                              <option value={ intl.formatMessage({id: "home.modal_vivenciadas.option9"}) }>{ intl.formatMessage({id: "home.modal_vivenciadas.option9"}) }</option>
                              <option value={ intl.formatMessage({id: "home.modal_vivenciadas.option10"}) }>{ intl.formatMessage({id: "home.modal_vivenciadas.option10"}) }</option>
                              <option value={ intl.formatMessage({id: "home.modal_vivenciadas.option11"}) }>{ intl.formatMessage({id: "home.modal_vivenciadas.option11"}) }</option>
                              <option value={ intl.formatMessage({id: "home.modal_vivenciadas.option12"}) }>{ intl.formatMessage({id: "home.modal_vivenciadas.option12"}) }</option>
                              <option value={ intl.formatMessage({id: "home.modal_vivenciadas.option13"}) }>{ intl.formatMessage({id: "home.modal_vivenciadas.option13"}) }</option>
                              <option value={ intl.formatMessage({id: "home.modal_vivenciadas.option14"}) }>{ intl.formatMessage({id: "home.modal_vivenciadas.option14"}) }</option>
                              <option value={ intl.formatMessage({id: "home.modal_vivenciadas.option15"}) }>{ intl.formatMessage({id: "home.modal_vivenciadas.option15"}) }</option>
                              <option value={ intl.formatMessage({id: "home.modal_vivenciadas.option16"}) }>{ intl.formatMessage({id: "home.modal_vivenciadas.option16"}) }</option>
                              <option value={ intl.formatMessage({id: "home.modal_vivenciadas.option17"}) }>{ intl.formatMessage({id: "home.modal_vivenciadas.option17"}) }</option>
                              <option value={ intl.formatMessage({id: "home.modal_vivenciadas.option18"}) }>{ intl.formatMessage({id: "home.modal_vivenciadas.option18"}) }</option>
                              <option value={ intl.formatMessage({id: "home.modal_vivenciadas.option19"}) }>{ intl.formatMessage({id: "home.modal_vivenciadas.option19"}) }</option>
                              <option value={ intl.formatMessage({id: "home.modal_vivenciadas.option20"}) }>{ intl.formatMessage({id: "home.modal_vivenciadas.option20"}) }</option>              
                              <option value={ intl.formatMessage({id: "home.modal_vivenciadas.option21"}) }>{ intl.formatMessage({id: "home.modal_vivenciadas.option21"}) }</option>
                              <option value={ intl.formatMessage({id: "home.modal_vivenciadas.option22"}) }>{ intl.formatMessage({id: "home.modal_vivenciadas.option22"}) }</option>
                           </select>
                        </div>
                     </div>

                     <div className="col-md-12">
                        <div className="form-group">
                           <label className="form-label" htmlFor="descricao"><FormattedMessage id="home.modal_vivenciadas.label5"/><span className="form-required">*</span></label>
                           <textarea
                              className={`form-input ${ errors.descricao && touched.descricao ? 'is-invalid' : '' }`}
                              placeholder={placeholder1}
                              type="text"
                              name="descricao"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.descricao}
                              required
                           ></textarea>
                        </div>
                     </div>

                     <div className="col-md-12">
                        <div className="form-group">
                           <label className="form-label" htmlFor="endereco"><FormattedMessage id="home.modal_situ.label13"/><span className="form-required">*</span></label>
                           <input
                              className={`form-input ${ errors.endereco && touched.endereco ? 'is-invalid' : '' }`}
                              placeholder={placeholder5}
                              type="text"
                              name="endereco"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.endereco}
                              required
                           />
                        </div>
                     </div>

                     <div className="col-md-6">
                        <div className="form-group">
                           <label className="form-label" htmlFor="data"><FormattedMessage id="home.modal_vivenciadas.label6"/><span className="form-required">*</span></label>
                           <input
                              className={`form-input ${ errors.data && touched.data ? 'is-invalid' : '' }`}
                              type="date"
                              name="data"
                              placeholder="dd/mm/yy"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.data}
                           />
                        </div>
                     </div>

                     <div className="col-md-6">
                        <div className="form-group">
                           <label className="form-label" htmlFor="data"><FormattedMessage id="home.modal_vivenciadas.label7"/><span className="form-required">*</span></label>
                           <select
                              className={`form-input ${ errors.periodo && touched.periodo ? 'is-invalid' : '' }`}
                              name="periodo"
                              placeholder="Periodo"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.periodo}
                           >
                              <option value="Manhã">{ intl.formatMessage({id: "home.modal_vivenciadas.option23"}) }</option>
                              <option value="Tarde">{ intl.formatMessage({id: "home.modal_vivenciadas.option24"}) }</option>
                              <option value="Noite">{ intl.formatMessage({id: "home.modal_vivenciadas.option25"}) }</option>
                           </select>
                        </div>
                     </div>

                     <div className="col-md-6">
                        <div className="form-group">
                           <label className="form-label" htmlFor="data"><FormattedMessage id="home.modal_vivenciadas.label8"/><span className="form-required">*</span></label>
                           <input
                              className={`form-input ${ errors.idade && touched.idade ? 'is-invalid' : '' }`}
                              type="number"
                              name="idade"
                              placeholder={placeholder2}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.idade}
                           />
                        </div>
                     </div>

                     <div className="col-md-6">
                        <div className="form-group">
                           <label className="form-label" htmlFor="renda"><FormattedMessage id="home.modal_vivenciadas.label9"/><span className="form-required">*</span></label>
                           <select
                              className={`form-input ${ errors.renda && touched.renda ? 'is-invalid' : '' }`}
                              name="renda"
                              placeholder="Renda"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.renda}
                           >
                              <option value="1">{ intl.formatMessage({id: "home.modal_vivenciadas.option26"}) }</option>
                              <option value="2">{ intl.formatMessage({id: "home.modal_vivenciadas.option27"}) }</option>
                              <option value="3">{ intl.formatMessage({id: "home.modal_vivenciadas.option28"}) }</option>
                              <option value="4">{ intl.formatMessage({id: "home.modal_vivenciadas.option29"}) }</option>
                              <option value="5">{ intl.formatMessage({id: "home.modal_vivenciadas.option30"}) }</option>
                              <option value="6">{ intl.formatMessage({id: "home.modal_vivenciadas.option31"}) }</option>
                           </select>
                        </div>
                     </div>

                     <div className="col-md-6">
                        <div className="form-group">
                           <label className="form-label" htmlFor="categoria"><FormattedMessage id="home.modal_vivenciadas.label11"/><span className="form-required">*</span></label>
                           <select
                              className={`form-input ${ errors.categoria && touched.categoria ? 'is-invalid' : '' }`}
                              name="ccategoria"
                              placeholder="Categoria Profissional"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.categoria}
                           >
                              <option value="D1">{ intl.formatMessage({id: "home.modal_vivenciadas.option45"}) }</option>
                              <option value="D2">{ intl.formatMessage({id: "home.modal_vivenciadas.option46"}) }</option>
                              <option value="D3">{ intl.formatMessage({id: "home.modal_vivenciadas.option47"}) }</option>
                              <option value="D4">{ intl.formatMessage({id: "home.modal_vivenciadas.option48"}) }</option>
                              <option value="D5">{ intl.formatMessage({id: "home.modal_vivenciadas.option49"}) }</option>
                              <option value="D6">{ intl.formatMessage({id: "home.modal_vivenciadas.option50"}) }</option>
                              <option value="D7">{ intl.formatMessage({id: "home.modal_vivenciadas.option51"}) }</option>
                              <option value="D8">{ intl.formatMessage({id: "home.modal_vivenciadas.option52"}) }</option>
                              <option value="D10">{ intl.formatMessage({id: "home.modal_vivenciadas.option54"}) }</option>
                              <option value="D11">{ intl.formatMessage({id: "home.modal_vivenciadas.option55"}) }</option>
                              <option value="D12">{ intl.formatMessage({id: "home.modal_vivenciadas.option56"}) }</option>
                              <option value="D13">{ intl.formatMessage({id: "home.modal_vivenciadas.option57"}) }</option>
                              <option value="D14">{ intl.formatMessage({id: "home.modal_vivenciadas.option58"}) }</option>
                              <option value="D15">{ intl.formatMessage({id: "home.modal_vivenciadas.option59"}) }</option>
                              <option value="D16">{ intl.formatMessage({id: "home.modal_vivenciadas.option60"}) }</option>
                              <option value="D17">{ intl.formatMessage({id: "home.modal_vivenciadas.option61"}) }</option>
                              <option value="D18">{ intl.formatMessage({id: "home.modal_vivenciadas.option62"}) }</option>
                              <option value="D19">{ intl.formatMessage({id: "home.modal_vivenciadas.option63"}) }</option>
                              <option value="D20">{ intl.formatMessage({id: "home.modal_vivenciadas.option64"}) }</option>
                              <option value="D21">{ intl.formatMessage({id: "home.modal_vivenciadas.option65"}) }</option>
                              <option value="D22">{ intl.formatMessage({id: "home.modal_vivenciadas.option66"}) }</option>
                              <option value="D23">{ intl.formatMessage({id: "home.modal_vivenciadas.option67"}) }</option>
                              <option value="D24">{ intl.formatMessage({id: "home.modal_vivenciadas.option68"}) }</option>
                              <option value="D25">{ intl.formatMessage({id: "home.modal_vivenciadas.option69"}) }</option>
                              <option value="D26">{ intl.formatMessage({id: "home.modal_vivenciadas.option70"}) }</option>
                           </select>
                        </div>
                     </div>

                     <div className="col-md-6">
                        <div className="form-group">
                           <label className="form-label" htmlFor="escolaridade"><FormattedMessage id="home.modal_vivenciadas.label10"/><span className="form-required">*</span></label>
                           <select
                              className={`form-input ${ errors.escolaridade && touched.escolaridade ? 'is-invalid' : '' }`}
                              name="escolaridade"
                              placeholder="Escolaridade"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.escolaridade}
                           >
                              <option value="1">{ intl.formatMessage({id: "home.modal_vivenciadas.option32"}) }</option>
                              <option value="2">{ intl.formatMessage({id: "home.modal_vivenciadas.option33"}) }</option>
                              <option value="3">{ intl.formatMessage({id: "home.modal_vivenciadas.option34"}) }</option>
                              <option value="4">{ intl.formatMessage({id: "home.modal_vivenciadas.option35"}) }</option>
                              <option value="5">{ intl.formatMessage({id: "home.modal_vivenciadas.option36"}) }</option>
                              <option value="6">{ intl.formatMessage({id: "home.modal_vivenciadas.option37"}) }</option>
                              <option value="7">{ intl.formatMessage({id: "home.modal_vivenciadas.option38"}) }</option>
                              <option value="8">{ intl.formatMessage({id: "home.modal_vivenciadas.option39"}) }</option>
                              <option value="9">{ intl.formatMessage({id: "home.modal_vivenciadas.option40"}) }</option>
                              <option value="10">{ intl.formatMessage({id: "home.modal_vivenciadas.option41"}) }</option>
                              <option value="11">{ intl.formatMessage({id: "home.modal_vivenciadas.option42"}) }</option>
                              <option value="12">{ intl.formatMessage({id: "home.modal_vivenciadas.option43"}) }</option>
                              <option value="13">{ intl.formatMessage({id: "home.modal_vivenciadas.option44"}) }</option>
                           </select>
                        </div>
                     </div>                  

                     <div className="col-md-6">
                        <div className="form-group">
                           <label className="form-label" htmlFor="sexo"><FormattedMessage id="home.modal_vivenciadas.label12"/><span className="form-required">*</span></label>
                           <select
                              className={`form-input ${ errors.sexo && touched.sexo ? 'is-invalid' : '' }`}
                              name="sexo"
                              placeholder="Sexo"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.sexo}
                           >
                              <option value="1">{ intl.formatMessage({id: "home.modal_vivenciadas.option71"}) }</option>
                              <option value="2">{ intl.formatMessage({id: "home.modal_vivenciadas.option72"}) }</option>
                              <option value="3">{ intl.formatMessage({id: "home.modal_vivenciadas.option73"}) }</option>
                           </select>
                        </div>
                     </div>

                     <div className="col-md-6">
                        <div className="form-group">
                           <label className="form-label" htmlFor="cor"><FormattedMessage id="home.modal_vivenciadas.label13"/><span className="form-required">*</span></label>
                           <select
                              className={`form-input ${ errors.cor && touched.cor ? 'is-invalid' : '' }`}
                              name="cor"
                              placeholder="Cor"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.cor}
                           >
                              <option value="1">{ intl.formatMessage({id: "home.modal_vivenciadas.option74"}) }</option>
                              <option value="2">{ intl.formatMessage({id: "home.modal_vivenciadas.option75"}) }</option>
                              <option value="3">{ intl.formatMessage({id: "home.modal_vivenciadas.option76"}) }</option>
                              <option value="2">{ intl.formatMessage({id: "home.modal_vivenciadas.option77"}) }</option>
                              <option value="3">{ intl.formatMessage({id: "home.modal_vivenciadas.option78"}) }</option>
                              <option value="2">{ intl.formatMessage({id: "home.modal_vivenciadas.option79"}) }</option>
                           </select>
                        </div>
                     </div>   
                  
                    <div className="col-md-12">
                        <div className="form-group">
                           <label className="form-label" htmlFor="email"><FormattedMessage id="home.modal_vivenciadas.label14"/><span className="form-required">*</span></label>
                           <input
                              className={`form-input ${ errors.nome && touched.nome ? 'is-invalid' : '' }`}
                              placeholder={placeholder3}
                              type="nome"
                              name="nome"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.nome}
                              required
                           />
                        </div>
                     </div>

                     <div className="col-md-12">
                        <div className="form-group">
                           <label className="form-label" htmlFor="email"><FormattedMessage id="home.modal_vivenciadas.label15"/><span className="form-required">*</span></label>
                           <input
                              className={`form-input ${ errors.email && touched.email ? 'is-invalid' : '' }`}
                              placeholder={placeholder4}
                              type="email"
                              name="email"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.email}
                              required
                           />
                        </div>
                     </div>
                   </div>
                  <p><FormattedMessage id="home.modal_vivenciadas.p2"/></p>
                  <button className="button button--primary" type="submit" disabled={isSubmitting}><FormattedMessage id="home.modal_vivenciadas.button"/></button>
               </form>
            )}
         </Formik>
      </div>
   )
}




export default injectIntl(withRouter(ModalVivenciado));
